//#region Imports

import {
    Component,
    EventEmitter,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';

import {ArticleDto, BasketArticleDto, CategoryDto, IBasketArticleDto} from '@shared/service-proxies/service-proxies';

import {appModuleAnimation} from '@axilla/axilla-shared';

import {WebShopBaseComponent} from '@app/webshop/shared/common/webshop-base.component';
import {Paginator} from 'primeng/paginator';
import {PageEvent} from '@app/webshop/shared/models';
import {takeUntil} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {BasketArticleExtendedDto} from '@app/shared/common/shop-system/models/models';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';

//#endregion Imports

@Component({
    selector: 'app-table-view',
    templateUrl: './table-view.component.html',
    styleUrls: ['./table-view.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class TableViewComponent extends WebShopBaseComponent implements OnInit, OnDestroy {
    @Output()
    openDetails: EventEmitter<any> = new EventEmitter();

    selectedArticle: BasketArticleDto;

    //#region Items
    private _items: BasketArticleDto[] = [];

    get items(): BasketArticleDto[] {
        return this._items;
    }

    @Input()
    set items(items: BasketArticleDto[]) {
        // Add logic to transform or validate input here
        this._items = items ? items : [];

        this.primengTableHelper.records = items;
    }
    //#endregion Items

    @Input()
    category?: CategoryDto;
    categoryId: string;

    @Output()
    searchAndLoadData: EventEmitter<any> = new EventEmitter();
    orderGuideId: string;

    isLoading = false;

    @ViewChild('paginator', { static: true }) paginator: Paginator;

    private currentPage$: Observable<number>;

    //#region First
    private _first = 0;

    // Getter for the `total` input property
    get first(): number {
        return this._first;
    }

    set first(value: number) {
        this._first = value ? value : 0; // Default to an empty array if the value is falsy
    }
    //#endregion First

    private currentBatch: any[] = []; // Current batch of articles (10 articles)
    private currentIndex = 0; // Index of the current batch
    private batchSize = 12; // Number of articles in a batch

    constructor(
        injector: Injector
    ) {
        super(injector);

        this.currentPage$ = this._combineViewService.currentPage$;

        this.currentBatch = this.items;
    }

    // Load the first batch of 10 articles
    private loadBatch() {
        const start = Math.floor(this.currentIndex / this.batchSize) * this.batchSize;
        this.currentBatch = this.items;
    }

    // Navigate to the next article
    nextArticle() {
        this.currentIndex++;
        // // If we've reached the end of the batch, load the next batch
        // if (this.currentIndex % this.batchSize === 0 && this.currentIndex < this.allArticles.length) {
        //     this.loadBatch();
        // }
        // // Prevent going out of bounds
        // if (this.currentIndex >= this.allArticles.length) {
        //     this.currentIndex = this.allArticles.length - 1; // Stay on the last article
        // }
    }

    // Navigate to the previous article
    previousArticle() {
        this.currentIndex--;
        // If we've moved to the previous batch, load it
        if (this.currentIndex % this.batchSize === this.batchSize - 1 && this.currentIndex >= 0) {
            this.loadBatch();
        }
        // Prevent going out of bounds
        if (this.currentIndex < 0) {
            this.currentIndex = 0; // Stay on the first article
        }
    }

    //#region Total Amount
    private _total = 0;

    // Getter for the `total` input property
    get total(): number {
        return this._total;
    }

    @Input()
    set total(value: number) {
        // Add logic to transform or validate input here
        this._total = value ? value : 0; // Default to an empty array if the value is falsy

        this.primengTableHelper.totalRecordsCount = this._total;
    }
    //#endregion Total Amount

    onOpenDetails(item: any) {
        this.openDetails.emit(item);
    }

    toggleFavorites($event: Event, product: ArticleDto) {
        if (!product.favorite) {
            this._addToFavorite($event, product);
        } else {
            this._removeFromFavorite($event, product);
        }

        //reload list
        this.onSearchAndLoadData();
    }

    showFavorites() {
        this.webshopService.showFavorites();
    }

    onSearchAndLoadData(event?: any) {
        let data = {
            event: event,
            //webshopCode: this.webshopCode,
            //webshopTitle: this.webshopTitle,
            primeng: this.primengTableHelper
        };

        if (event.rows !== this._combineViewService.currentRowsAmount) {
            this._combineViewService.setRowsAmount(event.rows);
        }

        this.searchAndLoadData.emit(data);
    }

    ngOnInit(): void {
        this.isLoading = true;

        //init totalAmount
        this.currentPage$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((currentPage) => {
                this.currentPage = currentPage;

                this.first = currentPage === 0 ? 0 : (currentPage * this.rowsAmount);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onRowClick(event: any) {
        const article = event.data;
        this.onOpenDetails(article);
    }

    addToBasket(article: BasketArticleDto) {
        this._addItemToBasket(article);
    }

    editLocalWarehouse(article: BasketArticleDto) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.permissionChecker.isGranted(BasePermissionDefinition.Webshop.WMS.EditLocalStock)) {
            abp.event.trigger('app.show.editLocalWarehouseModal', article);
        }
    }

}

